import { cx } from '@linaria/core';
import { useRef, useId } from 'react';
import { ElementToolbar } from '@pm2/element-toolbar';
import { breakpoints } from '@ui/css';
import { ComponentFrameworkTitle, ComponentFrameworkSaveIndicator, RetryButton } from '@utils/component-framework';
import { HideFor, ShowFor } from '@utils/react';
import { GGBAppletApiContext } from '../context.applet.js';
import { PrintLayout } from '../organism.print/organism.print.js';
import { wrapper, contextMenu, header, saveIndicatorPlaceholder, actionsWrapper, actions, elementToolbarPlaceholder, contentWrapper, saveIndicatorWrapper, saveIndicator, retryButton } from './_component.style.js';
import { useGGBApplet } from './hook.ggb-applet.js';
import { GeogebraContextMenu } from './integration.context-menu.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { GeogebraContent } from '../organism.content/_content.js';

function GeogebraComponent(props) {
  const rootRef = useRef(null);
  const printTargetRef = useRef(null);
  const appletRef = useRef(null);
  const appletClassName = `geogebra-applet--${useId().replace(/[^a-zA-Z0-9]/g, "-")}`;
  const [appletApi] = useGGBApplet(props, {
    appletRef,
    appletClassName
  });
  return /*#__PURE__*/jsx(GGBAppletApiContext.Provider, {
    value: appletApi,
    children: /*#__PURE__*/jsxs("div", {
      ref: rootRef,
      children: [/*#__PURE__*/jsxs("section", {
        className: cx(wrapper, props.className, props.context),
        children: [props.node && /*#__PURE__*/jsx(HideFor, {
          breakpoint: breakpoints.mobile.andDown(),
          className: contextMenu,
          children: /*#__PURE__*/jsx(ElementToolbar, {
            node: props.node
          })
        }), /*#__PURE__*/jsxs("header", {
          className: header,
          children: [/*#__PURE__*/jsx("div", {
            className: cx(saveIndicatorPlaceholder)
          }), /*#__PURE__*/jsx(ComponentFrameworkTitle, {
            title: props.component.envelope.Title,
            onCollapse: props.onCollapse,
            richtextDescription: props.context === "embedded" ? props.node?.meta.richTextDescription : undefined
          }), /*#__PURE__*/jsxs("div", {
            className: actionsWrapper,
            children: [/*#__PURE__*/jsx(GeogebraContextMenu, {
              className: actions,
              layout: "fab",
              componentRef: rootRef,
              printRef: printTargetRef,
              component: props.component,
              onShareWithTeacher: props.onShareWithTeacher
            }), /*#__PURE__*/jsx(ShowFor, {
              breakpoint: breakpoints.mobile.andDown(),
              children: /*#__PURE__*/jsx("div", {
                className: elementToolbarPlaceholder,
                children: props.node && /*#__PURE__*/jsx(ElementToolbar, {
                  node: props.node
                })
              })
            })]
          })]
        }), /*#__PURE__*/jsxs("div", {
          className: cx(contentWrapper),
          children: [/*#__PURE__*/jsx("div", {
            className: saveIndicatorWrapper,
            children: /*#__PURE__*/jsx("span", {
              className: saveIndicator,
              children: /*#__PURE__*/jsx(ComponentFrameworkSaveIndicator, {
                entryKey: props.component.entryKey
              })
            })
          }), /*#__PURE__*/jsx(GeogebraContent, {
            ref: appletRef,
            appletClassName: appletClassName,
            aspectRatio: props.component.data.aspectRatio
          })]
        }), props.component.data.flowType !== "random" && /*#__PURE__*/jsx(RetryButton, {
          className: retryButton,
          context: "button",
          onReset: props.onResetEntry
        })]
      }), /*#__PURE__*/jsx(PrintLayout, {
        ref: printTargetRef
      })]
    })
  });
}

export { GeogebraComponent };
//# sourceMappingURL=_component.js.map
